import { Button, Typography, withStyles } from '@material-ui/core';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import { FaqIcon } from '../icons';
import React from 'react';
import { Link } from 'react-router-dom';

const StyledHelpBtn = withStyles(theme => ({
  root: {
    borderRadius: '5px',
    backgroundColor: '#00000000',
    color: `${theme.palette.text.dynamic}!important`,
    width: 'fit-content !important',
    height: 'fit-content !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    padding: '4px 5px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      textDecoration: 'none !important'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '1rem',
      '& .MuiButton-label': {
        flexDirection: 'column'
      },
      '& .MuiSvgIcon-root': {
        margin: '0 !important',
        width: '23px !important',
        height: '23px !important'
      },
      [theme.breakpoints.down('xs')]: {
        width: '35px !important',
        minWidth: '35px !important',
        height: '35px',
        padding: 10,
        '& .MuiTypography-root': {
          display: 'none'
        }
      }
    }
  }
}))(Button);

const HelpBtn = () => {
  return (
    <StyledHelpBtn
      componant="a"
      target="_blank"
      rel="noopener noreferrer"
      href="https://form.asana.com/?k=WX11nBwEYhRg0fMwbdgggA&d=1200458275450520"
    >
      <FaqIcon
        style={{ marginRight: '8px', width: '28px', height: '28px'}}
      />
      <Typography style={{ fontFamily: 'sofia-pro', fontSize: '1.5rem' }}>
        Aide
      </Typography>
    </StyledHelpBtn>
  );
};

export default HelpBtn;
